const initialState = {
  toasts: []
}
let lastId = 0
function addToast (state, action) {
  state.toasts.push({
    id: action.id || lastId++,
    show: true,
    error: action.error,
    title: action.title,
    extraMessage: action.extraMessage,
    message: action.message,
    onClose: action.onClose
  })
  state.toasts = state.toasts.slice(0)
}

function closeToast (state, action) {
  for (let i = state.toasts.length; i--;) {
    if (state.toasts[i].id === action.id) {
      state.toasts.splice(i, 1)
    }
  }
  state.toasts = state.toasts.slice(0)
}

export default (state = initialState, action) => {
  switch (action.type) {
    case 'OPEN_TOAST':
      addToast(state, action)
      return { ...state }
    case 'CLOSE_TOAST':
      closeToast(state, action)
      return { ...state }
    default:
      return { ...state }
  }
}
